import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Error Icon from Figma
 * @link [Figma](https://www.figma.com/design/bUeKiC8YcV9PHrMlJAZUJG/Design-System?node-id=1099-9591&t=lZryLE1Oe0BuzeVH-4)
 * */

const ErrorIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8 9.333V5.656m.82-3.734a.938.938 0 0 0-1.64 0l-6.094 11.25a.938.938 0 0 0 .82 1.39h12.188a.938.938 0 0 0 .82-1.39L8.821 1.922ZM8.667 12a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0Z" className="stroke-current" strokeLinecap="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={16} height={16} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ErrorIcon;